import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Store } from '../models/storeCategory';
import { AppConstant } from '@app/shared/constants';
import {StoreDetail, StrAdmnCommissionFilterModel, StrAdmnPublishedProductFilterModel, StrAdmnPublishedProductUpdateModel, StrAdmnPublishedProductDeleteModel, StoreDetailKey, StrAdmnWareHousePublishedProductDeleteModel} from '../models/store';
import { environment } from '@env/environment';
import { StorePublishModel } from '@app/shared/models/storepublish';
import {ApiResponse, APIResponse} from '@app/shared/services/core/ICore.interface';
import {GetStoreListInterface} from '@app/feature/store-admin/services/GetStoreList.interface';
import {GetStoreInterface} from '@app/shared/services/common/getStoreList.interface';
import {GetStoreAdminCommissionListInterface} from '@app/feature/store-admin/services/GetStoreAdminCommissionList.interface';
import { E } from '@angular/cdk/keycodes';

@Injectable({
  providedIn: 'root'
})
export class StoreService {

  constructor(private http: HttpClient) { }

  /** Get store categories for category dropdown */
  getStoreCategories() {
    return this.http.get<any>(environment.baseUrl + AppConstant.STORECATEGORY_LIST);
  }
  /**Get store categories for store admin category dropdown */
  getStoreCategoriesList(userId:any) {
    return this.http.get<any>(environment.baseUrl + AppConstant.GetStoreCategoryList+userId);
  }



  /** Creates a new store */
  createStore(store: Store) {
    return this.http.post(environment.baseUrl + AppConstant.STORE_CREATE, store);
  }

  /** Update store with all data */
  updateStore(storeDetail: StoreDetail) {
    return this.http.post<APIResponse<any>>(environment.baseUrl + AppConstant.STORE_UPDATE, storeDetail);
  }

  /** Update store with all data */
  updateStoreKey(storeDetail: StoreDetailKey) {
    return this.http.post(environment.baseUrl + AppConstant.STORE_UPDATEKEY, storeDetail);
  }

  /** Update store with all data */
  updateStoreDesign(data: { StoreId: number, DesignSetting: string }) {
    const headers = new HttpHeaders();
    const headers_1 = headers.append('Authorization', 'Bearer ' + localStorage.getItem('userToken'));
    return this.http.post<APIResponse<any>>(environment.baseUrl + AppConstant.STORE_UPDATE_DESIGN, data, { headers: headers_1 });
  }

  /** Get Store by id */
  getStoreById(storeId: string) {
    const headers = new HttpHeaders();
    const headers_1 = headers.append('Authorization', 'Bearer ' + localStorage.getItem('userToken'));
    return this.http.get<APIResponse<GetStoreInterface>>(environment.baseUrl + AppConstant.STORE_GET + storeId, { headers: headers_1 });
  }

  /**Gets store listing with params: searchString, skipNoOfRecord, takeNoRecord, IsPaginationFilteringRequired.
   * IsPaginationFilteringRequired = false, means pagination, searching, filterinig is not required */
   getStoreList(searchString: any, skipNoOfRecord: number, takeNoRecord: number, IsPaginationFilteringRequired: boolean,
    ApplicationUserId: number, GetShopifyStore : boolean) {
    return this.http.get<APIResponse<GetStoreListInterface[]>>(environment.baseUrl + AppConstant.STORE_GETALL + '?searchBy=' + searchString +
    '&skipRecords=' + skipNoOfRecord + '&takeRecords=' + takeNoRecord + '&IsPaginationFilteringRequired=' + IsPaginationFilteringRequired +
    '&ApplicationUserId=' + ApplicationUserId + '&GetShopifyStore=' + GetShopifyStore);
  }


 //Addded by Rahul
  getPriceDetails(productId: any , designId: any, storeid: any) {
    // tslint:disable-next-line:max-line-length
    return this.http.get<any>(environment.baseUrl + AppConstant.GET_CUSTOMIZED_PRODUCT_DETAIL_BY_ID + '?ProductId=' + productId + '&DesignId=' + designId
    + '&StoreId=' + storeid);
  }
  getWareHousePriceDetails(warehoueProductId: any,) {
    return this.http.get<any>(environment.baseUrl + AppConstant.GET_CUSTOMIZED_WAREHOUSE_PRODUCT_DETAIL_BY_ID + '?WareHouseProductID=' + warehoueProductId)
  }

  /** Save store published products
   * @param storePublishModel StoreId, CustomizedProductId, UserId
   */
  saveStorePublishProducts(storePublishModel: StorePublishModel) {
    return this.http.post<any>(environment.baseUrl + AppConstant.PUBLISH_STORE_PRODUCT , storePublishModel);
  }

  /** Check whether same product is already published to same store or not
   * @param customizedProductId any,
   * @param storeId any,
   * @returns true/false bool
   */
  isProductAlreadyPublishedToSameStore(customizedProductId: any, storeId: any) {
    // tslint:disable-next-line:max-line-length
     return this.http.get<any>(environment.baseUrl + AppConstant.DUPLICATE_PRODUCT_PUBLISH + '?CustomizedProductId=' + customizedProductId +
    '&StoreId=' + storeId);
  }
  /** check the store name already exist or not */
  isStoreNameAlreadyExist(storeName: any) {
    const headers = new HttpHeaders();
    const headers_1 =  headers.append('Authorization', 'Bearer ' + localStorage.getItem('userToken'));
    return this.http.get<any>(environment.baseUrl + AppConstant.ISSORENAMEALREADYEXIST + '?StoreName=' + storeName, {headers: headers_1});
  }

  GetStoreAdminCommissionList(filterModel: StrAdmnCommissionFilterModel) {
    return this.http.post<APIResponse<GetStoreAdminCommissionListInterface[]>>(environment.baseUrl + AppConstant.STOREADMIN_COMMISSION_LIST, filterModel);
  }

  GetStoreAdminPublishedProductList(filterModel: StrAdmnPublishedProductFilterModel) {
    return this.http.post(environment.baseUrl + AppConstant.STOREADMIN_PUBLISHED_PRODUCT_LIST, filterModel);
  }

  UpdateStoreAdminPublishedProductList(updatePublishProductModel: StrAdmnPublishedProductUpdateModel) {
    return this.http.post(environment.baseUrl + AppConstant.UPDATE_STOREADMIN_PUBLISHED_PRODUCT_LIST, updatePublishProductModel);
  }
  updateRetailPriceForWareHouseProduct(wareHouseProductId: any, RetailPrice) {
    return this.http.get<any>(environment.baseUrl + AppConstant.UPDATE_RETAILPRICE_FOR_WAREHOUSE + '?WareHouseProductId=' + wareHouseProductId + '&Profit=' + RetailPrice)
  }
  DeleteStoreAdminPublishedProductList(deleteublishProductModel: StrAdmnPublishedProductDeleteModel) {
    return this.http.post(environment.baseUrl + AppConstant.DELETE_STOREADMIN_PUBLISHED_PRODUCT_LIST, deleteublishProductModel);
  }
  DeleteStoreAdminWareHouseProduct(deleteublishProductModel: StrAdmnWareHousePublishedProductDeleteModel) {
    return this.http.post(environment.baseUrl + AppConstant.DELETE_WAREHOUSE_PRODUCT, deleteublishProductModel);
  }

  /**
   * This func calls to fetch stores of particular user and checks whether particular product can be published or not
   * i.e (already published or not)
   * @param userId: number
   * @param customizedProductId : number
   */
  GetStoresForProductPublish(userId: number, customizedProductId: number, warehouseProductId:number) {
    const headers = new HttpHeaders();
    const headers_1 =  headers.append('Authorization', 'Bearer ' + localStorage.getItem('userToken'));
    return this.http.get<any>(environment.baseUrl + AppConstant.GET_STORES_FOR_PRODUCT_PUBLISH + '?UserId=' + userId + '&CustomizedProductId=' + customizedProductId + '&WarehouseProductId=' + warehouseProductId, {headers: headers_1});
  }
  //Function  call delete store
  DeleteStore(storeId: any) {
    return this.http.get<any>(environment.baseUrl + AppConstant.Delete_Store + '?StoreId='+ storeId);
  }
  /** Check Shopify Store */
  getShopifyStore(domainName: string) {
    return this.http.get<APIResponse<any>>(environment.baseUrl + AppConstant.SHOPIFY_STORE_GET + '?domainName=' + domainName);
  }
  /** Add Shopify Store */
  addShopifyStore(obj: any) {
    return this.http.post<APIResponse<any>>(environment.baseUrl + AppConstant.SHOPIFY_STORE_ADD, obj);
  }
}
